import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3924 21.4641L18.5359 15.6076L22.9283 11.2152C24.5486 9.59492 27.1645 9.59492 28.7848 11.2152C30.4051 12.8355 30.4051 15.4514 28.7848 17.0717L24.3924 21.4641Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2152 28.7847C9.59492 27.1644 9.59492 24.5485 11.2152 22.9282L15.6076 18.5358L21.4641 24.3923L17.0717 28.7847C15.4612 30.405 12.8355 30.405 11.2152 28.7847Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6603 16.3397L16.3397 23.6604",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgLink);
export default ForwardRef;
